<template>
  <main class="any-link">
    <div class="any-link-panel">
      <span class="tab-title">any link</span>
      <a class="edit-btn" @click="showModal = true" data-cy="any-link-edit-button">edit</a>
      <span class="error">{{ error }}</span>
      <template v-for="(link, index) in anylinks">
        <div class="any-link-collection">
          <div class="image">
            <div class="thumbnail-image" :style="{ backgroundImage: `url(${link.thumbnail ? cleanThumbnailUrl(link.thumbnail.url) : defaultThumbnailImage })` }"></div>
          </div>
          <div class="any-link-details">
            <span class="flex-end ellipsis">{{ link.title }}</span>
            <span class="ellipsis">{{ link.url | stripHttpProtocolUtil }}</span>
          </div>
        </div>
      </template>
      <any-link-modal v-if="showModal"
                      :anylinks.sync="anylinks"
                      :communication-id="communicationId"
                      @hideModal="hideModal" />
    </div>
    <div class="cancel-extension" @click="clickedOnCancel()">cancel</div>
  </main>
</template>

<script>
import AnyLinkModal from "./modals/any-link-modal-old.vue";
import {campaignAPI} from "../../../services/api/campaignAPI.js";
import {autoCampaignMessageAPI} from "../../../services/api/autoCampaignMessageAPI.js";
import defaultThumbnailImage from "stashboard/default_thumbnail_image.png";
import {stripHttpProtocolUtil} from "../../../utilities";
import {mapGetters} from "vuex";

const genericErrorMessage = "error, please refresh or contact support";

export default {
  props: {
    autocampaignMessageId: [Number, String]
  },

  name: "any-link",

  components: {AnyLinkModal},

  data(){
    return {
      anylinks: [],
      defaultThumbnailImage,
      error: null,
      showModal: false
    }
  },

  async created(){
    const anyLinksFromCurrentCommunication = await this.communicationAPI.getAnyLinks(this.communicationId)

    if(anyLinksFromCurrentCommunication){
      this.anylinks = anyLinksFromCurrentCommunication
      if(anyLinksFromCurrentCommunication.length === 0) this.showModal = true
    }else{
      this.error = genericErrorMessage
    }
  },

  computed: {
    ...mapGetters(['campaign']),

    communicationAPI() {
      return this.campaign ? campaignAPI : autoCampaignMessageAPI
    },

    communicationId() {
      return (this.campaign) ? this.campaign.id : this.autocampaignMessageId
    }
  },

  methods: {
    cleanThumbnailUrl(url) {
      if(url.startsWith("http")) {
        return `${url}?h=47&w=47`
      }
      return url
    },

    async clickedOnCancel() {
      this.$emit("setExtension", 0)
    },

    hideModal(state) {
      this.showModal = state
    }
  },

  filters: {
    stripHttpProtocolUtil
  }
}
</script>

<style scoped>
.any-link {
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-between;
  text-align: left;
}

.any-link .any-link-panel {
  display: flex;
  flex-direction: column;
}

.any-link .cancel-extension {
  font-family: "AileronThin";
  width: 100%;
}

.any-link header {
  color: #4a4a4a;
  font-size: 16px;
  line-height: 1.8;
  text-align: left;
}

.any-link sub {
  color: #4a4a4a;
  font-size: .75rem;
}

.any-link span {
  font-size: .8rem;
  line-height: 1.25;
}

.any-link span.tab-title {
  align-self: center;
  font-family: "AileronLight";
  font-size: 1.125em;
}

.any-link .edit-btn {
  align-self: center;
  font-size: 0.83em;
}

.any-link .flex-end {
  align-self: flex-end;
}

.any-link .any-link-collection {
  display: flex;
  flex-flow: row nowrap;
  margin: 10px 0;
}

.any-link .any-link-details {
  display: flex;
  flex-flow: row wrap;
}

.any-link .ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  width: 152px;
}

.any-link .any-link-details span {
  flex-basis: 100%;
  padding-left: 5px;
}

.any-link .any-link-details span:first-child {
  font-family: "AileronLight";
  font-size: .85em;
}

.any-link .thumbnail-image {
  background-color: #fff;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 50%;
  height: 47px;
  margin: 0 auto;
  width: 47px;
}

.any-link .thumbnail-image img {
  height: auto;
  width: 100%;
}
</style>